import HeaderLogo from "../assets/images/logo-completo-bianco.svg";
import HeaderLogoSmall from "../assets/images/logo-bianco.svg";
import "../assets/styles/components/navbar.scss";
import Menu from "../assets/icons/menu";
import Bell from "../assets/icons/bell";
import UserRounded from "../assets/icons/user-rounded";
import Dot from "../assets/icons/dot";

export default function Navbar({ context, notifications }) {
  return (
    <nav
      id="navbar"
      className={`py-2 px-3 d-flex flex-wrap align-items-center ${
        context.session ? "session-nav position-sticky" : ""
      }`}
    >
      <div className="nav-container mx-auto w-100 d-flex flex-row align-items-center position-relative">
        <img
          onClick={() => context.navigateUrl("/")}
          className={`logo d-block ${
            context.session ? "me-auto" : "mx-auto"
          } my-2`}
          src={context.session ? HeaderLogoSmall : HeaderLogo}
        />
        {context.session ? (
          <div className="user-action position-absolute d-flex align-items-center">
            {context.session ? (
              <div
                className="profile d-flex align-items-center"
                onClick={() => context.openProfilePanel(context)}
              >
                <div className="d-flex flex-column align-items-end justify-content-center me-2">
                  <small>Ciao</small>
                  <small>
                    {`${context.session.firstName} ${context.session.lastName}`}
                  </small>
                </div>
                <UserRounded size={26} color="#ffffff" />
              </div>
            ) : null}
            <div className="mx-3 position-relative d-flex align-items-center justify-content-center">
              <Bell
                size={24}
                color="#ffc61e"
                onClick={() =>
                  context.openNotifications(context, notifications)
                }
              />

              {notifications &&
              notifications.filter((x) => !x.read).length > 0 ? (
                <Dot
                  size={10}
                  color="#f7323f"
                  className="position-absolute ms-3 mb-4"
                />
              ) : null}
            </div>

            <Menu
              size={26}
              color="#ffffff"
              onClick={() => context.openMenu(context)}
            />
          </div>
        ) : null}
      </div>
    </nav>
  );
}
